import Vue from 'vue'
import VueRouter from 'vue-router'
import VueCookies from "vue-cookies";

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    name: "index",
    component: () => import("../page/Home.vue"),
    redirect: '/project',
    children: [
      {
        path: "project",
        name: "project",
        component: () => import("../component/ProjectList.vue")
      },
      {
        path: "",
        name: "detail",
        component: () => import("../component/ProjectDetail.vue")
      }
    ]
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../page/login.vue")
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    // console.log('router.beforeEach,login page')
    return next()
  }

  const token = VueCookies.get("token")
  
  if (!token) {
    console.log("to",to.query)
    let query = to.query
  
    return next({path:"/login",query:query})
  }

  if(to.path === '/' && JSON.stringify(to.query)==='{}'){
    // console.log('首次加载页面,清空tabs缓存')
    //首次加载页面,清空tabs缓存
    // VueCookies.remove('tabs')
    localStorage.removeItem('tabs')
    VueCookies.remove('actived_tab')
    return next({path: to.path, query: {keepAlive: 1,corpId:"$CORPID$"}})
  }else{
    return next()
  }

})

export default router
